import React, {Fragment, useRef} from "react";
// import {Swiper, SwiperSlide} from "swiper/react";
// import {Pagination} from "swiper";
import LazyLoad from 'react-lazy-load';

import {getLengt_bk} from "../../clientconfigwebapp";
import {Skeleton} from "@mui/material";
 import {Link} from "react-router-dom";

import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import '../assets/css/carousel.css'
const Slider_show_home = (props) => {

    return (
      <Fragment>
          {
              props.data_slider_list.length > 0 ? (


                  <Swiper   className='w-100 home-swiper-container'
                            modules={[Pagination]}
                            spaceBetween={50}
                            slidesPerView={1}
                            pagination={{ clickable: true }}
                            onSwiper={(swiper) => console.log(swiper)}
                            onSlideChange={() => console.log('slide change')}
                            autoplay={true}
                            lazy={true}
                            dir={"ltr"}


                  >

                      {


                          (() => {

                              if(getLengt_bk(props.data_slider_list) >=1 ){


                                  return (


                                      props.data_slider_list.map((item_curent,index) => {

                                          return (
                                              <Fragment>
                                                  <SwiperSlide className='w-100 home-swiper-slide'>

                                                      <a href={item_curent.link_slider} className='w-100'>
                                                          <img style={{borderRadius:"15px"}} src={item_curent.image_src} alt={item_curent.image_alt} className='w-100'/>
                                                      </a>

                                                  </SwiperSlide>
                                              </Fragment>
                                          );


                                      })

                                  )


                              }

                          })()



                      }

                  </Swiper>
              ):(

                  <Fragment>
                      <div className={"slider-home-karimian"}>
                          <Skeleton variant="rectangular"  style={{"width":"100%","height":"40vh","marginTop":"24px","borderRadius":"12px"}}  />
                      </div>
                  </Fragment>




              )


          }




      </Fragment>
    );
  }
  
  export default Slider_show_home;